module.exports = __webpack_public_path__ + "img/aprogsys.3ac760cf.png";